<template>
<el-form ref="form" :model="form" label-width="100px">
    <el-form-item label="Excel">
      <el-upload
          class="upload-demo"
          action="/api/Upload/fileupload.html"
          :on-preview="handlePreview1"
          :on-remove="handleRemove1"
          :on-success="handleAvatarSuccess1"
          :file-list="form.fileList1"
          list-type="text"
          name="image[]"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">
            文件不超过50Mb
        </div>
      </el-upload>
      <el-input v-model="form.l_file" type="hidden"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
<!--      <el-button @click="go">取消</el-button>-->
    </el-form-item>
  </el-form>
</template>
<script>
import axios from "axios";

export default {
  name: "LeaderView",
  data() {
    return {
      form: {
        l_file:'',
        fileList1: [],
      },
      fileList: [],
    };
  },
  created() {
    //this.getBase();
  },
  methods: {
    getBase(){
      axios.get('/api/Leader/index.html').then((res)=>{
          if(res.data.code == 200)  this.form = res.data.data;
      });
    },
    handleAvatarSuccess1(res) {
      let array = Object.values(res);
      this.form.l_file = array[0]['file_url'];
    },
    handleRemove1(file, fileList1) {
      console.log(file, fileList1);
    },
    handlePreview1(file) {
      console.log(file);
    },

    handleChange(value) {
      console.log(value);
    },
    onSubmit() {
        this.axios({
          method:'post',
          url:'/api/Leader/setLeader.html',
          data:this.form
        }).then((res)=>{
          if(res.data.code != 200) {
            alert(res.data.msg);
          }
          else{
            alert(res.data.msg);
          }
        })
    },
  },
};
</script>
<style scoped lang='scss'>
.el-input-number {
  margin-left: 10px;
}
.el-radio-button{
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  vertical-align: middle;
  display: inline-block;
}
</style>